module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-3-fca2b9d96f96f9e2af9e46f6d88d98d9.png";